const school = {
    title:'School',
    schoolName:'School Name',
    address:'Address',
    province:'Province',
    district:'District',
    save:'Save',
    cancel:'Cancel',
    addSchool:'Add School',
    dob:'DOB',
    IEMISNumber:'IEMIS Number',
    schoolsList: 'Schools List',
    selectProvince: 'Select Province',
    selectDistrict: 'Select District',
    search: 'Search schools...',
    studentsAtSchool: 'Students at this school',
    noStudents: 'No students found',
    viewProfile: 'View',
    studentsCount: 'Students Count',
};
export default school;